module.exports = __webpack_public_path__ + "static/media/wrecker_orange.ac6be868.svg";